import {observable} from 'mobx';

import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {CompetitorDomainModel} from "../../../domain/common/competitor/models/competitor-domain-model";
import {ScoreboardWidgetScoreCellViewModel} from "./scoreboard-widget.score-cell-view-model";
import {SportPossessionLogoPrams} from "../../../domain/sports/models/sport.possesion.logo-params";
import {GameCompetitorDomainModel} from "../../../domain/partial-game/models/game-competitor/game-competitor-domain-model";
import {CompetitorLinkModel} from "../../../containers/competitor-container/models/competitor-link-model";

export class ScoreboardWidgetCompetitorViewModel extends BaseViewModel {
  domainModel: GameCompetitorDomainModel;
  @observable cells: Array<ScoreboardWidgetScoreCellViewModel>;

  constructor(domainModel: CompetitorDomainModel, cells: Array<ScoreboardWidgetScoreCellViewModel>) {
    super(domainModel);

    this.cells = cells;
  }

  get name(): String {
    const name: String = this.domainModel.shortName || this.domainModel.name;

    return name;
  }

  get linkModel(): CompetitorLinkModel {
    const linkModel: CompetitorLinkModel = new CompetitorLinkModel(this.id, this.domainModel.sport.nameForURL, this.domainModel.nameForURL, this.domainModel.isFollow);

    return linkModel;
  }

  get isWinner(): Boolean {
    return this.domainModel.isWinner;
  }

  get inPossession(): Boolean {
    return this.domainModel.inPossession;
  }

  get possessionLogoParams(): SportPossessionLogoPrams {
    return new SportPossessionLogoPrams({height: 12, width:12}, this.domainModel.sport);
  }

  get aggregatedScore(): Number {
    return this.domainModel.aggregatedScore;
  }

  get isQualified(): Boolean {
    return this.domainModel.isQualified;
  }

  get toQualify(): Boolean {
    return this.domainModel.toQualify;
  }
}
